import type { RtRequest } from "src/components/ReactiveTable/RtRequest";

import type { ZFilterGroup } from "../types/ZFilterApiTypes";
import type { ZFilterSearchSortItem } from "../types/ZFilterSearchTypes";
import {
  mapTableSortToFilterSort,
  type ResolveSortFieldType,
} from "./mapTableSortToFilterSort";

type FilterSearchRequest = RtRequest<{
  queryBuilderFilter?: ZFilterGroup;
}>;

export type { FilterSearchRequest };

type BuildFilterSearchPayloadOptions = {
  resolveSortFieldType?: ResolveSortFieldType;
};

type FilterSearchPayload = {
  filters: ZFilterGroup[];
  page: {
    size: number;
    offset: number;
  };
  sort?: ZFilterSearchSortItem[];
};

export const buildFilterSearchPayload = (
  request: FilterSearchRequest,
  options: BuildFilterSearchPayloadOptions = {},
): FilterSearchPayload => {
  const pageSize = request.pageSize ?? 10;

  return {
    filters: request.filters?.queryBuilderFilter
      ? [request.filters.queryBuilderFilter]
      : [],
    page: {
      size: pageSize,
      offset: request.page * pageSize,
    },
    sort: mapTableSortToFilterSort(
      request.sortOrder,
      options.resolveSortFieldType,
    ),
  };
};
